import { CSSObject, Theme } from '@emotion/react';
import { mobile } from 'styles/media';

const wrap = (time: boolean): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '8px 6px',
  '> div': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    '> p': {
      margin: '0 4px',
      color: '#8B95A1',
    },
    '> button': {
      width: time ? '66px' : '90px',
    },
  },
  [mobile]: {
    '> div': {
      flexWrap: 'wrap',
    },
  },
});

const btns: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '6px',
  marginTop: '2px',
};

const btn =
  (isSelected: boolean) =>
  (theme: Theme): CSSObject => ({
    height: '36px',
    padding: '0 12px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: isSelected ? 600 : 500,
    color: isSelected ? theme.color.white : theme.color.grey600,
    background: isSelected ? theme.color.primary : theme.color.grey75,
    borderRadius: '10px',
    transition: 'background-color 0.15s ease',
  });

export { wrap, btns, btn };
